import React from "react";
import "./spinner.css"; // Import the CSS file here

const SpinnerComponent = () => {
  return (
    <div className="body ">
      <div className="spinner">
        <div className="spinnerin"></div>
      </div>
    </div>
  );
};

export default SpinnerComponent;
